import { nanoid } from '@ant-design/pro-components';
import { Tabs, TabsProps } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
// icons
import { ROUTES } from 'base/routes/routes';
import PageWrapper from 'pages/Components/PageWrapper';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SYSTEM_TITLE } from 'utils/constants';
import { checkPermission } from 'utils/permissionHelper';
import createContactSegmentation from '..';
import AddContactSegment from './addContactSegment';
import ContactSegmentDetail from './detailContactSegment';

type TargetKey = React.MouseEvent | React.KeyboardEvent | string;


const ContactSegmentation = createContactSegmentation();


const createDetailContactSegment = () => {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.contact-seg') + ' - ' + SYSTEM_TITLE;

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    // lấy id của tab (nếu như có id là tab xem chi tiết)
    const tabId = searchParams.get('tabId');
    const typeTab = searchParams.get('type');
    const tabName = searchParams.get('tabName');

    // ==================================== STATE ===================================================
    const [idTabDetail, setIdtabDetail] = useState(() => {
      if (tabId && typeTab === 'detail') return tabId;
      return undefined;
    });

    const [deleteKey, setDeleteKey] = useState('');

    // ============================================ XỬ LÝ TABS =========================================

    const [activeKey, setActiveKey] = useState('1');
    const [items, setItems] = useState<TabsProps['items']>([
      {
        label: t('segment.danh-sach'),
        key: '1',
        closable: false,

        children: <ContactSegmentation />
      },
    ]);

    const onChange = (newActiveKey: string) => {
      // if (newActiveKey === '1') {
      //   navigate(ROUTES.CUSTOMER.CONTACT_SEGMENTATION.LINK);
      // } else {
      //   navigate(
      //     ROUTES.CUSTOMER.CONTACT_SEGMENTATION.DETAIL.LINK +
      //     `?type=${newActiveKey === idTabDetail ? 'detail&tabId=' + newActiveKey : 'create'}`,
      //   );
      // }
      setActiveKey(newActiveKey);
    };
    const addNewTab = () => {
      if (items) {
        const newActiveKey = nanoid();
        const newPanes = [...items];
        newPanes.push({
          label: t('btn.create'),
          children: <AddContactSegment onMoveTab={removeKey} tabID={newActiveKey + ''} />,
          key: newActiveKey,
        });
        setItems(newPanes);
        setActiveKey(newActiveKey);
        // navigate(ROUTES.CUSTOMER.CONTACT_SEGMENTATION.DETAIL.LINK + `?type=create`);
      }
    };
    const addTabDetail = () => {
      if (items) {
        const newActiveKey = tabId as string;
        const newPanes = [...items];
        const hasDetail = newPanes.find((i) => i.key === tabId);
        if (!hasDetail) {
          newPanes.push({
            label: `${t('message.view')} ${tabName}`,
            children: <ContactSegmentDetail contactSegmentationId={tabId as string} />,
            key: newActiveKey,
          });
          setItems(newPanes);
        }
        setActiveKey(newActiveKey);
      }
    };

    const remove = (targetKey: TargetKey) => {
      if (items && items.length > 2) {
        let newActiveKey = activeKey;
        let lastIndex = -1;
        items.forEach((item, i) => {
          if (item.key === targetKey) {
            lastIndex = i - 1;
          }
        });
        const newPanes = items.filter((item) => item.key !== targetKey);
        if (newPanes.length && newActiveKey === targetKey) {
          if (lastIndex >= 0) {
            if (lastIndex > 0) {
              newActiveKey = newPanes[lastIndex].key;
            } else {
              newActiveKey = newPanes[newPanes.length - 1].key;
            }
          } else {
            newActiveKey = newPanes[0].key;
          }
        }
        setItems(newPanes);
        setActiveKey(newActiveKey);
      } else {
        navigate(ROUTES.CUSTOMER.CONTACT_SEGMENTATION.LINK);
      }
    };

    const onEdit = (targetKey: React.MouseEvent | React.KeyboardEvent | string, action: 'add' | 'remove') => {
      if (action === 'add') {
        // addNewTab();
      } else {
        remove(targetKey);
      }
    };

    const removeKey = (targetKey: string) => {
      setDeleteKey(targetKey);
    };

    useEffect(() => {
      if (typeTab) {
        console.log('type', typeTab);
        switch (typeTab) {
          case 'create':
            if (checkPermission('CREATE')) {
              addNewTab();
            }
            else navigate(ROUTES.CUSTOMER.CONTACT_SEGMENTATION.LINK);
            break;
          case 'detail':
            addTabDetail();
            break;
          default:
            break;
        }
      } else {
        navigate(ROUTES.CUSTOMER.CONTACT_SEGMENTATION.LINK);
      }
    }, [tabId]);

    useEffect(() => {
      if (deleteKey) {
        remove(deleteKey);
      }
    }, [deleteKey]);

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.contact-seg'),
          },
        ]}
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <Tabs
            // mục đích là để load lại request (destroy rồi mount lại)
            destroyInactiveTabPane
            activeKey={activeKey}
            type={checkPermission('CREATE') ? 'editable-card' : 'card'}
            size={'small'}
            onEdit={onEdit}
            hideAdd={true}
            onChange={onChange}
            className={
              'h-full [&_.ant-tabs-tab]:!rounded-t-sm [&_.ant-tabs-tab]:!text-default [&_.ant-tabs-tab]:!font-semibold [&_.ant-tabs-tab:hover]:!text-primary [&_.ant-tabs-tab]:!border-gray-300 [&>.ant-tabs-nav_.ant-tabs-tab]:!bg-gray-200 ' +
              '[&>.ant-tabs-nav_.ant-tabs-tab.ant-tabs-tab-active]:!bg-white [&_.ant-tabs-tab-active]:!border-b-white [&_.ant-tabs-tab-active>div]:!text-primary [&_.ant-tabs-nav]:!mb-0 [&_.ant-tabs-nav::before]:!border-b-gray-300 ' +
              '[&_.ant-tabs-nav-add]:!border [&_.ant-tabs-nav-add]:!border-gray-300 '
            }
            items={items}
          />
        </BoxContainer>
      </PageWrapper>
    );
  });
};

export default createDetailContactSegment;
